import { initAjaxLoadMore } from './ajax-load-more';

export function initNewsFeedLoadMore(root?: ParentNode): void {
  const scope = root ?? document;

  initAjaxLoadMore(scope, {
    gridSelector: '[data-news-grid]',
    wrapSelector: '[data-news-load-more-wrap]',
    btnSelector: '[data-news-load-more]',
    cardSelector: 'article.news-card',
    initFlag: 'newsLoadMoreBound',
  });
}
